export const getCasePlanTabSelector = store => store.casePlanTab;
